// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1807":"bbc27c66","3283":"a4fe211c","5680":"8b13fb74","5877":"7aef5d45","8080":"f5af5f49","8481":"bbc27c66","8688":"33a6aff9","9476":"e3c59aa8"}[chunkId] + ".chunk.css";
};